import { render, staticRenderFns } from "./service-type-icon.vue?vue&type=template&id=4b299fd1&"
import script from "./service-type-icon.vue?vue&type=script&lang=js&"
export * from "./service-type-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports